import { render, staticRenderFns } from "./PurchasingBoard.vue?vue&type=template&id=49e9e313&"
import script from "./PurchasingBoard.vue?vue&type=script&lang=js&"
export * from "./PurchasingBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports